module.exports = __webpack_public_path__ + "static/media/sponser.2c4a76eb.jpg";